import { uniq } from 'lodash';
import difference from 'lodash/difference';
import isEmpty from 'lodash/isEmpty';
import { IConfiguratorOption } from 'src/redux/configurator/configurator.duck.interface';

export const getAvailableOptionIds = (
    options: string[] = [],
    carOptions: IConfiguratorOption[] = [],
    mandatoryOptions: string[] = []
): string[] => {
    let availableOptionIdsToSelect = carOptions.map((o) => o.id);
    if (mandatoryOptions.length) {
        availableOptionIdsToSelect = uniq([...availableOptionIdsToSelect, ...mandatoryOptions]);
    }
    const optionsNotAvailableAnymore = difference(options, availableOptionIdsToSelect);

    if (!isEmpty(optionsNotAvailableAnymore)) {
        const newOptions = options.filter((so) => !optionsNotAvailableAnymore.includes(so));

        return newOptions;
    }

    return options;
};
